module.exports = __webpack_public_path__ + "static/media/pointCommande.0822b578.png";